<kui-card width="460">
    <app-auth-header />

    <kui-divider />

    <kui-alert
        [message]="translations.information.no_user"
        color="warn"
        background="warn-background" />

    <kui-divider />

    <kui-button
        type="tertiary"
        color="primary"
        fullWidth
        [label]="translations.global.logout"
        (click)="appService.logout()"
        [loading]="appService.loadingLogout()" />
</kui-card>
